// export class PaymentType extends Object {
//     id: number;
//     name = '';
// }


export enum ContractItemType {
    product = 'product',
    group = 'group',
    delivery = 'delivery',
    deployment = 'deployment',
    text = 'text',
    other = 'other'
}



// WEBPACK FOOTER //
// /app/src/model/Entities/ContractItemType.ts